/**
 * Sanctioned countries — Bahnhof.cloud services are not offered in Russia or Belarus.
 *
 * Every form that lets the customer pick a country (billing, contact, registration)
 * or a phone dial code checks its selection here, shows RestrictedCountryNotice
 * and refuses to submit while a restricted country is selected.
 *
 * Matched on the ISO key the API lists countries under and on the country name,
 * so a non-ISO key cannot slip past the check. A dial code is never checked on
 * its own: +7 is shared with Kazakhstan, so the phone field checks the country
 * the code was picked for.
 */
export const RESTRICTED_COUNTRY_KEYS = ['RU', 'BY']
export const RESTRICTED_COUNTRY_NAMES = ['russia', 'belarus']

export const isRestrictedCountry = (key?: string | number | null, name?: string | null): boolean =>
  RESTRICTED_COUNTRY_KEYS.includes(String(key ?? '').toUpperCase()) ||
  RESTRICTED_COUNTRY_NAMES.some(restricted =>
    String(name ?? '')
      .toLowerCase()
      .includes(restricted),
  )
